
<div fxFlex="100%" class="general-message" fxLayoutAlign="center">
            Thank you! We'll get back to you as soon as possible!
</div>